module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Italic.e40bf407.woff";